<div class="px-3 py-2">
	<h4 align="center">Young Applied Mathematicians Conference 2026</h4>
	<p><a href="https://www.yamc.it" target="_blank">www.yamc.it</a></p>

	<p>The Sixth Edition of the <b>Young Applied Mathematicians Conference (YAMC)</b> in 
		<b>Torino</b> is organized by Ph.D. students, PostDocs and RTDa researchers from 
		University of Florence, University of Padua, Politecnico di Torino, University of 
		Siena, KAUST and SISSA.</p>

	<p>In particular, the conference targets Master's students, PhD students, and PostDocs 
		interested in the fields of Numerical Modelling, Numerical Analysis, Machine Learning, 
		Statistics, <b>Cryptography</b> and Security and Privacy.</p>

	<p>Each conference day will open with a plenary lecture delivered by a senior speaker. 
		The remaining time will be devoted to contributed talks. Participants are strongly 
		encouraged to present their research in <b>30-minute presentations (25' + 5' Q&A)</b> 
		in the main track, while mini-symposia talks may last up to 30 minutes, according to 
		the organizers' schedule. Short courses (1 hour) to introduce general topics are also 
		welcomed. To allow everyone to talk, two parallel tracks will be organized.</p>
</div>